export const userConstats = {
  CODE_KEY: 'VAQTI SOATING KELGANDA JAVOB BERASAN'
};
